
export const COLORS = {
    PRIMARY_COLOR : '#e30614',
    ERROR: '#FF2C2C',
    WARNING: "#FFD700",
    SUCCESS : "#008000",
    ACTIVE : "#008000",
    INACTIVE : "#808080",
    LINK: "#1976d2",
}
